import React, { Component } from "react";

class SelectBox extends Component {
  render() {
    const { changeHandler, defaultText, label, name, options, selectedValue } =
      this.props;

    return (
      <label className="globalopps-form" htmlFor={`sel_${name}`}>
        <div className="globalopps-form__label"><legend>{label}<span> *</span></legend></div>
        <select name={name} onChange={changeHandler} value={selectedValue} id={`sel_${name}`}>
          <option value="any" defaultValue>
            {defaultText}
          </option>
          {options &&
            options
              .sort((a, b) => (a.text > b.text ? 1 : -1))
              .map((option, index) => (
                <option key={index} value={option.text}>
                  {option.text}
                </option>
              ))}
        </select>
      </label>
    );
  }
}

export default SelectBox;
